/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Recipient_EmailInputs */

const cs_field_recipient_email = /** @type {(inputs: Field_Recipient_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail příjemce`)
};

const en_field_recipient_email = /** @type {(inputs: Field_Recipient_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recipient email`)
};

/**
* | output |
* | --- |
* | "Recipient email" |
*
* @param {Field_Recipient_EmailInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const field_recipient_email = /** @type {((inputs?: Field_Recipient_EmailInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Recipient_EmailInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_recipient_email(inputs)
	return cs_field_recipient_email(inputs)
});